import * as actionTypes from './../Register_action.types';
import * as api from './../register_api_services/generateForm.api';


export const CreateGenerateFormData = (formtDataInput) => ({
  type: actionTypes.CREATE_GENERATE_FORM_REQUEST,
  payload: formtDataInput,
});

export const CreateGenerateFormDataSuccess = (user) => ({
  type: actionTypes.CREATE_GENERATE_FORM_SUCCESS,
  payload: user,
});

export const CreateGenerateFormDataFailure = (error) => ({
  type: actionTypes.CREATE_GENERATE_FORM_FAILURE,
  payload: error,
});


export const CreateGenerateFormInput = (formtDataInput, options = {}) => {
  return async (dispatch) => {
    dispatch(CreateGenerateFormDataSuccess(formtDataInput));
    try {
      const response = await api.CreateGenerateForm(formtDataInput, options);
      if (response.data == null) {
        dispatch(CreateGenerateFormDataFailure(response.error));
        return { success: false, message: response.error, payload: response.errorPayload || null };
      }
      if (response.status === 200) {
        dispatch(CreateGenerateFormDataSuccess(response.data.user));
        return { success: true, message: response, data: response };
      } else {
        dispatch(CreateGenerateFormDataFailure(response.message || ' input failed'));
        return { success: false, message: response.data.message };
      }
    } catch (error) {
      dispatch(CreateGenerateFormDataFailure(error));
      return { success: false, message: error };
    }
  };
};


// uploadGeneratedFormFile,getGeneratedFormAll,getGeneratedForm,updateGeneratedFormById,deleteGeneratedFormById

export const uploadGeneratedFormRequest = (fileData) => ({
  type: actionTypes.UPLOAD_GENERATED_FORM_REQUEST,
  payload: fileData,
});

export const uploadGeneratedFormSuccess = (message) => ({
  type: actionTypes.UPLOAD_GENERATED_FORM_SUCCESS,
  payload: message,
});

export const uploadGeneratedFormFailure = (error) => ({
  type: actionTypes.UPLOAD_GENERATED_FORM_FAILURE,
  payload: error,
});

export const uploadGeneratedFormFile = (fileData) => {
  return async (dispatch) => {
    dispatch(uploadGeneratedFormRequest(fileData));
    try {
      const response = await api.uploadGeneratedForm(fileData);
      dispatch(uploadGeneratedFormSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(uploadGeneratedFormFailure(error));
      return { success: false, message: error };
    }
  };
};

export const getGeneratedFormAlRequest = () => ({
  type: actionTypes.GET_GENERATED_FORM_REQUEST,
});


export const getGeneratedFormAllSuccess = (GeneratedForm) => ({
  type: actionTypes.GET_GENERATED_FORM_SUCCESS,
  payload: GeneratedForm,
});

export const getGeneratedFormAllFailure = (error) => ({
  type: actionTypes.GET_GENERATED_FORM_FAILURE,
  payload: error,
});

export const getGeneratedFormAll = () => {
  return async (dispatch) => {
    dispatch(getGeneratedFormAlRequest());
    try {
      const GeneratedForm = await api.fetchAllGeneratedForms();
      dispatch(getGeneratedFormAllSuccess(GeneratedForm));
      return { success: true, data: GeneratedForm };
    } catch (error) {
      dispatch(getGeneratedFormAllFailure(error));
      return { success: false, message: error };
    }
  };
};



export const getGeneratedFormRequest = (current_month) => ({
  type: actionTypes.GET_GENERATED_FORM_REQUEST,
  payload: current_month,
});

export const getGeneratedFormSuccess = (GeneratedForm) => ({
  type: actionTypes.GET_GENERATED_FORM_SUCCESS,
  payload: GeneratedForm,
});

export const getGeneratedFormFailure = (error) => ({
  type: actionTypes.GET_GENERATED_FORM_FAILURE,
  payload: error,
});

export const getGeneratedForm = (current_month) => {
  return async (dispatch) => {
    dispatch(getGeneratedFormRequest(current_month));
    try {
      const GeneratedForm = await api.fetchGeneratedForm(current_month);
      dispatch(getGeneratedFormSuccess(GeneratedForm));
      return { success: true, data: GeneratedForm };
    } catch (error) {
      dispatch(getGeneratedFormFailure(error));
      return { success: false, message: error };
    }
  };
};


export const updateGeneratedFormRequest = (id, GeneratedFormData) => ({
  type: actionTypes.UPDATE_GENERATED_FORM_REQUEST,
  payload: { id, GeneratedFormData },
});

export const updateGeneratedFormSuccess = (message) => ({
  type: actionTypes.UPDATE_GENERATED_FORM_SUCCESS,
  payload: message,
});

export const updateGeneratedFormFailure = (error) => ({
  type: actionTypes.UPDATE_GENERATED_FORM_FAILURE,
  payload: error,
});

export const updateGeneratedFormById = (id, GeneratedFormData) => {
  return async (dispatch) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    GeneratedFormData.updated_by = user.user_name;

    dispatch(updateGeneratedFormRequest(id, GeneratedFormData));
    try {
      const response = await api.updateGeneratedForm(id, GeneratedFormData);
      dispatch(updateGeneratedFormSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(updateGeneratedFormFailure(error));
      return { success: false, message: error };
    }
  };
};



export const deleteGeneratedFormRequest = (id) => ({
  type: actionTypes.DELETE_GENERATED_FORM_REQUEST,
  payload: id,
});

export const deleteGeneratedFormSuccess = (message) => ({
  type: actionTypes.DELETE_GENERATED_FORM_SUCCESS,
  payload: message,
});

export const deleteGeneratedFormFailure = (error) => ({
  type: actionTypes.DELETE_GENERATED_FORM_FAILURE,
  payload: error,
});

export const deleteGeneratedFormById = (id) => {
  return async (dispatch) => {
    dispatch(deleteGeneratedFormRequest(id));
    try {
      const response = await api.deleteGeneratedForm(id);
      dispatch(deleteGeneratedFormSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(deleteGeneratedFormFailure(error));
      return { success: false, message: error };
    }
  };
};


export const generated_forms_downloadDataRequest = (id) => ({
  type: actionTypes.GENERATED_FORM_DOWNLOAD_REQUEST,
  payload: id,
});

export const generated_forms_downloadDataSuccess = (data) => ({
  type: actionTypes.GENERATED_FORM_DOWNLOAD_SUCCESS,
  payload: data,
});

export const generated_forms_downloadDataFailure = (error) => ({
  type: actionTypes.GENERATED_FORM_DOWNLOAD_FAILURE,
  payload: error,
});


export const Generated_forms_downloadDataInput = (id, downloadName, format = "excel") => {
  return async (dispatch) => {
    dispatch(generated_forms_downloadDataRequest(id));
    try {
      const response = await api.generated_forms_download_file(id, downloadName, format);

      if (response?.error || response?.data == null) {
        const msg = response?.error || "Download failed";
        dispatch(generated_forms_downloadDataFailure(msg));
        return { success: false, message: msg };
      }

      dispatch(generated_forms_downloadDataSuccess());
      const label =
        format === "pdf" ? "PDF" : format === "both" ? "Excel + PDF (ZIP)" : "Excel";
      return { success: true, message: `${label} downloaded successfully` };
    } catch (error) {
      console.error("Error from generated_forms_download:", error);
      const msg = error?.message || "Download failed";
      dispatch(generated_forms_downloadDataFailure(msg));
      return { success: false, message: msg };
    }
  };
};

export const Generated_forms_downloadZip = (ids, filename, format = "excel") => {
  return async () => {
    try {
      const response = await api.generated_forms_download_zip(ids, filename, format);
      if (response?.error || response?.data == null) {
        return { success: false, message: response?.error || "Download failed" };
      }
      const label =
        format === "pdf" ? "PDF" : format === "both" ? "Excel + PDF" : "Excel";
      return { success: true, message: `${label} forms downloaded successfully` };
    } catch (error) {
      return { success: false, message: error?.message || "Download failed" };
    }
  };
};


export const getClientBaseUnitsFormRequest = (clinet_id) => ({
  type: actionTypes.GET_GENERATED_FORM_REQUEST,
  payload: clinet_id,
});

export const getClientBaseUnitsFormSuccess = (unitData) => ({
  type: actionTypes.GET_GENERATED_FORM_SUCCESS,
  payload: unitData,
});

export const getClientBaseUnitsFormFailure = (error) => ({
  type: actionTypes.GET_GENERATED_FORM_FAILURE,
  payload: error,
});

export const getClientBaseUnitsForm = (clinet_id) => {
  return async (dispatch) => {
    dispatch(getClientBaseUnitsFormRequest(clinet_id));
    try {
      const data = await api.get_client_base_units_form(clinet_id);
      dispatch(getClientBaseUnitsFormSuccess(data));
      return { success: true, data: data };
    } catch (error) {
      dispatch(getClientBaseUnitsFormFailure(error));
      return { success: false, message: error };
    }
  };
};



export const fetchGeneratedFormsList = (filters = {}) => {
  return async () => {
    try {
      const rows = await api.fetchGeneratedFormsFiltered({
        clientId: filters.client_id,
        unitId: filters.unit_id,
        kind: filters.kind,
        overview: filters.overview,
      });
      if (filters.overview) {
        return {
          success: true,
          data: rows && !Array.isArray(rows) && typeof rows === "object" ? rows : {},
        };
      }
      return {
        success: true,
        data: Array.isArray(rows) ? rows : [],
      };
    } catch (error) {
      return {
        success: false,
        message: error,
        data: filters.overview ? {} : [],
      };
    }
  };
};

export const releaseGeneratedFormById = (id) => {
  return async () => {
    try {
      const response = await api.releaseGeneratedForm(id);
      return {
        success: true,
        data: response,
        message: response.message || "Form released successfully",
      };
    } catch (error) {
      return { success: false, message: error };
    }
  };
};

export const releaseGeneratedFormsBulk = (ids) => {
  return async () => {
    try {
      const response = await api.releaseGeneratedFormsBulk(ids);
      return {
        success: true,
        data: response,
        message: response.message || "Forms released successfully",
      };
    } catch (error) {
      return { success: false, message: error };
    }
  };
};

export const Generated_forms_viewDataInput = (formData) => {
  return async () => {
    try {
      const result = await api.fetchStoredGeneratedFormBlob(formData);

      if (result?.error) {
        return { success: false, message: result.error };
      }
      if (result?.blob && result?.status === 200) {
        return {
          success: true,
          blob: result.blob,
          format: formData.format || 'pdf',
        };
      }
      return { success: false, message: 'View failed' };
    } catch (error) {
      return { success: false, message: error.message };
    }
  };
};

export const Generated_forms_viewById = (id) => {
  return async () => {
    try {
      const result = await api.generated_forms_view_file(id);
      if (result?.error) {
        return { success: false, message: result.error };
      }
      if (result?.blob && result?.status === 200) {
        return { success: true, blob: result.blob, format: "pdf" };
      }
      return { success: false, message: "View failed" };
    } catch (error) {
      return { success: false, message: error.message };
    }
  };
};
